/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React, { Component } from 'react';
import {
    Route, Routes,
} from 'react-router-dom';

import ManagedMatchTemplatesContainer from "./ManagedMatchTemplatesContainer";
import CreateManagedMatchTemplateContainer from "./CreateManagedMatchTemplateContainer";
import EditManagedMatchTemplateContainer from "./EditManagedMatchTemplateContainer";

export default class ManagedMatchTemplatesRouter extends Component {
    static propTypes = {

    };

    static defaultProps = {

    };

    render() { // eslint-disable-line
        return (
            <Routes>
                <Route path="/create" element={<CreateManagedMatchTemplateContainer/>} />
                <Route path="/:id/edit" element={<EditManagedMatchTemplateContainer/>} />
                <Route path="/" element={<ManagedMatchTemplatesContainer/>} />
            </Routes>
        );
    }
}
